import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReconciliation = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 1.5,
		y: 4.125,
		width: 10.375,
		height: 10.375,
		rx: 2.5,
		stroke: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12 1C13.6569 1 15 2.34315 15 4V9.375C15 10.9121 13.8436 12.1754 12.3535 12.3506C12.3669 12.2355 12.375 12.1186 12.375 12V11.3379C13.3001 11.1622 14 10.3513 14 9.375V4C14 2.89543 13.1046 2 12 2H6.625C5.64873 2 4.83778 2.69986 4.66211 3.625H4C3.88007 3.625 3.76176 3.63182 3.64551 3.64551C3.82087 2.15571 5.08808 1 6.625 1H12Z",
		fill: "currentColor"
	})]
});
export default SvgReconciliation;
